import { cloneDeep } from 'lodash';
import { QuestionType, TYPE_ADD_TEST_QUESTION, TestCategoryType } from './constants';
import { capitalizeFirstLetter } from './helper';
import { FileObject } from "models/test-attack-file.model";
import { TestDetailQuizModel, TestQuestionAnswer } from "models/test-detail.model";

// UI Components
export const headerEditor = (
  <span className="ql-formats">
    <button className="ql-bold" aria-label="Bold" />
    <button className="ql-italic" aria-label="Italic" />
    <button className="ql-underline" aria-label="Underline" />
    <button className="ql-strike" aria-label="Strike" />
    <button className="ql-blockquote" aria-label="Blockquote" />
    <button className="ql-align" aria-label="Align" />
    <button className="ql-code-block" />
    <select className="ql-color" />
    <select className="ql-background" />
    <select className="ql-font" />
    <select className="ql-direction" />
    <select className="ql-clean" />
    <select className="ql-header">
      <option value="1">Heading 1</option>
      <option value="2">Heading 2</option>
      <option value="3">Heading 3</option>
      <option value="4">Heading 4</option>
      <option value="5">Heading 5</option>
      <option value="6">Heading 6</option>
      <option value="">Normal</option>
    </select>
    <select className="ql-size">
      <option value="small" />
      <option value="normal" />
      <option value="large" />
      <option value="huge" />
    </select>
    <button className="ql-script" value="sub" />
    <button className="ql-script" value="super" />
    <button className="ql-list" value="ordered" />
    <button className="ql-list" value="bullet" />
    <button className="ql-indent" value="-1" />
    <button className="ql-indent" value="+1" />
  </span>
);


export const updateParams = (
  params: { fieldName: string; fieldValue: string }[],
  pathname: string,
  location: { search: string },
  history: { push: (location: { pathname: string; search: string }) => void }
) => {
  const searchParams = new URLSearchParams(location.search);
  params.forEach((p) => {
    searchParams.set(p.fieldName, p.fieldValue);
  });
  history.push({ pathname, search: searchParams.toString() });
};


export const validateQuestion = (n: TestDetailQuizModel): any => {
  let correctCount = 0;

  if (n.testQuestionTypeCode === QuestionType.dung_sai) {
    const userAnswer = n?.userAnswer?.length ? n.userAnswer[0] : -2;
    const correct = n?.testQuestionAnswers?.find((e: TestQuestionAnswer) => e.isCorrect)?.order ?? 0;
    n.isUserSelect = userAnswer === correct;

  } else if ([QuestionType.nhieu_lua_chon, QuestionType.mot_lua_chon].includes(n.testQuestionTypeCode)) {
    const correctOrders = n.testQuestionAnswers
      .filter((e: any) => e.isCorrect)
      .map((e: any) => e.order);

    const userAnswers = n.userAnswer || [];
    let isValid = true;

    if (userAnswers.length === 0) {
      isValid = false;
    } else {
      correctOrders.forEach((e: number) => {
        if (userAnswers.includes(e)) {
          if (n.testQuestionTypeCode === QuestionType.nhieu_lua_chon) correctCount += 1;
        } else {
          isValid = false;
        }
      });
    }

    n.isUserSelect = isValid;

  } else if (n.testQuestionTypeCode === QuestionType.dien_vao_nhieu_khoang_trong) {
    const clone = cloneDeep(n.multiplePositionAnswer || []).map((position: any) => {
      if (!Array.isArray(position.childQuestionAnswers)) {
        position.childQuestionAnswers = [];
      }
      position.childQuestionAnswers.forEach((ans: TestQuestionAnswer) => {
        ans.answer = (ans.answer || '').replace(/ /g, '').toLowerCase();
      });
      return position;
    });

    const userAnswers = (n.userAnswer || []).map((e: string) => (e || '').replace(/ /g, '').toLowerCase());
    let isValid = true;

    if (userAnswers.length === 0 || clone.length === 0) {
      isValid = false;
    } else {
      for (let i = 0; i < clone.length; i++) {
        const match = clone[i].answer.match(/\[(\d+)\]/);
        if (match) {
          const index = parseInt(match[1]) - 1;
          const input = userAnswers[index] || '-*-TNT-*-';
          const correctAnswers = (clone[i].childQuestionAnswers || [])
            .filter((a: TestQuestionAnswer) => a.isCorrect)
            .map((a: TestQuestionAnswer) => a.answer);

          if (correctAnswers.includes(input)) {
            correctCount += 1;
          } else {
            isValid = false;
          }
        }
      }
    }

    n.isUserSelect = isValid;

  } else if (n.testQuestionTypeCode === QuestionType.dien_vao_cho_trong) {
    const correctAnswers = n.testQuestionAnswers
      .filter((e: TestQuestionAnswer) => e.isCorrect)
      .map((e: TestQuestionAnswer) => (e.answer || '').replace(/ /g, '').toLowerCase());

    let userAnswer = '';
    let isValid = false;

    if (Array.isArray(n.userAnswer)) {
      userAnswer = (n.userAnswer[0] || '').replace(/ /g, '').toLowerCase();
    }

    if (correctAnswers.includes(userAnswer)) {
      isValid = true;
    }

    n.isUserSelect = isValid;

  } else if (n.testQuestionTypeCode === QuestionType.phu_hop) {
    const userAnswers = n.userAnswer || [];
    let isValid = true;

    n.testQuestionAnswers.forEach((answer: TestQuestionAnswer, index: number) => {
      if (!userAnswers.length || userAnswers[index] !== answer.answerRight) {
        isValid = false;
      } else {
        correctCount += 1;
      }
    });

    n.isUserSelect = isValid;

  } else if (n.testQuestionTypeCode === QuestionType.nhieu_trinh_tha_don_xuong) {
    const positions = (n.multiplePositionAnswer || []).map((pos: any) => {
      if (!Array.isArray(pos.childQuestionAnswers)) {
        pos.childQuestionAnswers = [];
      }
      return pos;
    });

    const userAnswers = n.userAnswer || [];
    let isValid = true;

    if (userAnswers.length === 0 || positions.length === 0) {
      isValid = false;
    } else {
      for (let i = 0; i < positions.length; i++) {
        let selected = -1;
        if (userAnswers[i] >= 0) selected = userAnswers[i];

        const correctOrders = positions[i].childQuestionAnswers
          .filter((e: any) => e.isCorrect)
          .map((e: any) => e.order);

        if ((selected || selected === 0) && correctOrders.includes(selected)) {
          correctCount += 1;
        } else {
          isValid = false;
        }
      }
    }

    n.isUserSelect = isValid;
  }

  // Tính điểm
  if (n.isUserSelect) {
    n.manualPoint = +n.point;
    n.stockPoint = +n.point;
  } else if (
    [QuestionType.nhieu_trinh_tha_don_xuong, QuestionType.dien_vao_nhieu_khoang_trong, QuestionType.nhieu_lua_chon, QuestionType.phu_hop].includes(n.testQuestionTypeCode)
  ) {
    let total = 1;

    if (n.testQuestionTypeCode === QuestionType.nhieu_lua_chon) {
      total = n.testQuestionAnswers?.filter((e: any) => e.isCorrect).length || 1;
    } else if (n.testQuestionTypeCode === QuestionType.dien_vao_nhieu_khoang_trong) {
      total = n.multiplePositionAnswer?.length || 1;
    } else {
      total = n.testQuestionAnswers?.length || 1;
    }

    if (correctCount > 0) {
      n.stockPoint = Math.round((correctCount / total) * +n.point * 100) / 100;
    } else {
      n.stockPoint = 0;
    }

    n.manualPoint = n.stockPoint;
  } else {
    n.manualPoint = 0;
    n.stockPoint = 0;
  }

  return { ...n };
};

export const validateNewQuestion = (question: TestDetailQuizModel): TestDetailQuizModel => {
  let correctCount = 0;
  const q = question;

  const clean = (text: string | null) => 
                (text || "")
                .replace(/ /g, "")
                .replace(/\s+/g, " ")
                .replace("‘", "'")
                .replace("`", "'")
                .trim()
                .toLowerCase();

  switch (q.testQuestionTypeCode) {
    case QuestionType.dung_sai: {
      const userAnswer = q.userAnswer?.[0] ?? -2;
      const correctAnswerOrder = q.testQuestionAnswers?.find(a => a.isCorrect)?.order ?? 0;
      q.isUserSelect = userAnswer === correctAnswerOrder;
      break;
    }

    case QuestionType.nhieu_lua_chon:
    case QuestionType.mot_lua_chon: {
      const correctOrders = q.testQuestionAnswers.filter(a => a.isCorrect).map(a => a.order);
      const userAnswers = q.userAnswer || [];
      let allCorrect = userAnswers.length > 0;

      for (const correct of correctOrders) {
        if (userAnswers.includes(correct)) {
          if (q.testQuestionTypeCode === QuestionType.nhieu_lua_chon) correctCount += 1;
        } else {
          allCorrect = false;
        }
      }

      q.isUserSelect = allCorrect;
      break;
    }

    case QuestionType.dien_vao_nhieu_khoang_trong: {
      const positions = (q.multiplePositionAnswer || []).map(pos => {
        if (!Array.isArray(pos.childQuestionAnswers)) pos.childQuestionAnswers = [];
        pos.childQuestionAnswers.forEach(ans => {
          //ans.answer = clean(ans.answer);
        });
        return pos;
      });

      const userAnswers = (q.userAnswer || []).map((ans: string) => clean(ans));
      let allCorrect = userAnswers.length > 0 && positions.length > 0;

      positions.forEach((pos, i) => {
        const match = pos.answer.match(/\[(\d+)\]/);
        if (match) {
          const index = +match[1] - 1;
          const userAnswer = userAnswers[index] || "-*-TNT-*-";
          const correctAnswers = (pos.childQuestionAnswers || [])
            .filter(a => a.isCorrect)
            .map(a => clean(a.answer));

          if (correctAnswers.includes(userAnswer)) {
            correctCount++;
          } else {
            allCorrect = false;
          }
        }
      });

      q.isUserSelect = allCorrect;
      break;
    }

    case QuestionType.dien_vao_cho_trong: {
      const correctAnswers = q.testQuestionAnswers.map(a => clean(a.answer));
      const userAnswer = clean(q.userAnswer?.[0] ?? "");
      q.isUserSelect = correctAnswers.includes(userAnswer);
      break;
    }

    case QuestionType.phu_hop: {
      let allCorrect = true;
      q.testQuestionAnswers.forEach((answer, index) => {
        if(answer.answerLeft != '')
        {
          const userAnswers = q.userAnswer || [];
          if (!userAnswers.length || userAnswers[index] !== answer.answerRight) {
            allCorrect = false;
          } else {
            correctCount++;
          }
        }
        
      });
      q.isUserSelect = allCorrect;
      break;
    }

    case QuestionType.nhieu_trinh_tha_don_xuong: {
      const positions = (q.multiplePositionAnswer || []).map(pos => {
        if (!Array.isArray(pos.childQuestionAnswers)) pos.childQuestionAnswers = [];
        return pos;
      });

      const userAnswers = q.userAnswer || [];
      let allCorrect = userAnswers.length > 0 && positions.length > 0;

      positions.forEach((pos, i) => {
        const userVal = userAnswers[i];
        const correctOrders = (pos.childQuestionAnswers || []).filter(a => a.isCorrect).map(a => a.order);
        if (correctOrders.includes(userVal)) {
          correctCount++;
        } else {
          allCorrect = false;
        }
      });

      q.isUserSelect = allCorrect;
      break;
    }
  }

  // Gán điểm
  if (q.isUserSelect) {
    q.manualPoint = +q.point;
    q.stockPoint = +q.point;
  } else if (
    [
      QuestionType.nhieu_trinh_tha_don_xuong,
      QuestionType.dien_vao_nhieu_khoang_trong,
      QuestionType.nhieu_lua_chon,
      QuestionType.phu_hop,
    ].includes(q.testQuestionTypeCode)
  ) {
    let totalCorrect = q.testQuestionAnswers?.length || 1;

    if (q.testQuestionTypeCode === QuestionType.nhieu_lua_chon) {
      totalCorrect = q.testQuestionAnswers?.filter(a => a.isCorrect).length || 1;
    } else if (q.testQuestionTypeCode === QuestionType.dien_vao_nhieu_khoang_trong) {
      totalCorrect = q.multiplePositionAnswer?.length || 1;
    }

    q.stockPoint = correctCount > 0
      ? Math.round((correctCount / totalCorrect) * +q.point * 100) / 100
      : 0;
    q.manualPoint = q.stockPoint;
  } else {
    q.manualPoint = 0;
    q.stockPoint = 0;
  }

  return { ...q };
};



export const GetTypeTestQuestion = (type: number): number => {
  if (type === TYPE_ADD_TEST_QUESTION.ADD_NEW) {
    return TYPE_ADD_TEST_QUESTION.ADD_NEW;
  }
  if (type === TYPE_ADD_TEST_QUESTION.OLD_QUESTION_NOT_CHANGE) {
    return TYPE_ADD_TEST_QUESTION.OLD_QUESTION_CHANGE;
  }
  if (type === TYPE_ADD_TEST_QUESTION.QUESTION_FROM_LIBRARY_NOT_CHANGE) {
    return TYPE_ADD_TEST_QUESTION.QUESTION_FROM_LIBRARY_CHANGE;
  }
  if (type === TYPE_ADD_TEST_QUESTION.OLD_QUESTION_CHANGE) {
    return TYPE_ADD_TEST_QUESTION.OLD_QUESTION_CHANGE;
  }
  if (type === TYPE_ADD_TEST_QUESTION.QUESTION_FROM_LIBRARY_CHANGE) {
    return TYPE_ADD_TEST_QUESTION.QUESTION_FROM_LIBRARY_CHANGE;
  }

  return type;
};

// Hàm mới để xử lý logic cập nhật isAdd dựa trên createdBy
export const GetTypeTestQuestionWithPermission = (type: number, createdBy: string, currentUserId: string): number => {
  // Nếu là câu hỏi từ thư viện và chưa thay đổi
  if (type === TYPE_ADD_TEST_QUESTION.QUESTION_FROM_LIBRARY_NOT_CHANGE) {
    // Kiểm tra xem người tạo câu hỏi có phải là người dùng hiện tại không
    if (createdBy === currentUserId) {
      // Nếu là người tạo thì giữ nguyên isAdd để cập nhật câu hỏi trong thư viện
      return TYPE_ADD_TEST_QUESTION.QUESTION_FROM_LIBRARY_NOT_CHANGE;
    } else {
      // Nếu không phải người tạo thì đổi thành QUESTION_FROM_LIBRARY_CHANGE để tạo câu hỏi mới
      return TYPE_ADD_TEST_QUESTION.QUESTION_FROM_LIBRARY_CHANGE;
    }
  }
  
  // Các trường hợp khác giữ nguyên logic cũ
  if (type === TYPE_ADD_TEST_QUESTION.ADD_NEW) {
    return TYPE_ADD_TEST_QUESTION.ADD_NEW;
  }
  if (type === TYPE_ADD_TEST_QUESTION.OLD_QUESTION_NOT_CHANGE) {
    return TYPE_ADD_TEST_QUESTION.OLD_QUESTION_CHANGE;
  }
  if (type === TYPE_ADD_TEST_QUESTION.OLD_QUESTION_CHANGE) {
    return TYPE_ADD_TEST_QUESTION.OLD_QUESTION_CHANGE;
  }
  if (type === TYPE_ADD_TEST_QUESTION.QUESTION_FROM_LIBRARY_CHANGE) {
    return TYPE_ADD_TEST_QUESTION.QUESTION_FROM_LIBRARY_CHANGE;
  }

  return type;
};

export const typeTemplate = (rowData: FileObject): JSX.Element => {
  const { type, url, file } = rowData;
  const src = file ? URL.createObjectURL(file) : url;

  if (type.startsWith('image/')) {
    return <img src={src} alt="Preview" style={{ width: '100%' }} />;
  }

  if (type.startsWith('video/')) {
    return <video src={src} controls style={{ width: '100%' }} />;
  }

  if (type.startsWith('audio/')) {
    return <audio src={src} controls />;
  }

  if (type === 'application/pdf') {
    return <iframe src={src} title="PDF Viewer" width="100%" height="500px" />;
  }

  return (
    <span title="Tệp không xem trước được">
      <i className="pi pi-file"></i>
    </span>
  );
};

export const getMedia = (selectedFile: FileObject): JSX.Element => {
  const { type, name } = selectedFile;
  let icon = 'pi pi-file';

  if (type.startsWith('image/')) icon = 'pi pi-image';
  else if (type.startsWith('video/')) icon = 'pi pi-video';
  else if (type.startsWith('audio/')) icon = 'pi pi-volume-up';
  else if (type === 'application/pdf') icon = 'pi pi-file-pdf';
  else if (type.includes('word')) icon = 'pi pi-file-word';
  else if (type.includes('excel')) icon = 'pi pi-file-excel';
  else if (type.includes('presentation')) icon = 'pi pi-file-powerpoint';
  else if (type.includes('zip') || type.includes('rar')) icon = 'pi pi-file-archive';

  return (
    <span title={type}>
      <i className={icon} style={{ marginRight: '8px' }}></i>
      {name}
    </span>
  );
};

export const getFieldType = (
  fieldType: string
): '' | ' (BG)' | ' (BT)' | ' (KT)' | ' (OL)' | undefined => {
  switch (fieldType) {
    case TestCategoryType.bai_giang:
      return ' (BG)';
    case TestCategoryType.bai_tap:
      return ' (BT)';
    case TestCategoryType.kiem_tra:
      return ' (KT)';
    case TestCategoryType.offline:
      return ' (OL)';
    default:
      return fieldType ? '' : undefined;
  }
};

export const getFieldTypeElm = (fieldType: string): JSX.Element | '' | undefined => {
  switch (fieldType) {
    case 'bai-giang':
      return <span title="Bài giảng"> (BG)</span>;
    case 'bai-tap':
      return <span title="Bài tập"> (BT)</span>;
    case 'kiem-tra':
      return <span title="Kiểm tra"> (KT)</span>;
    case 'offline':
      return <span title="Offline"> (OL)</span>;
    default:
      return '';
  }
};
export const getFieldName = (field: string) => {
  if (field === 'user_id') return 'Mã học sinh';
  if (field === 'user_name') return 'Tên học sinh';
  return capitalizeFirstLetter(field || '');
};

export const isFormFieldValid = (formik: any, name: string) =>
  !!(formik.touched[name] && formik.errors[name]);

export const getFormErrorMessage = (formik: any, name: string) =>
  isFormFieldValid(formik, name) ? (
    <small className="p-error">{formik.errors[name]}</small>
  ) : null;
